import { render, staticRenderFns } from "./SidebarGeometryInput.vue?vue&type=template&id=0dedaebc&scoped=true&"
import script from "./SidebarGeometryInput.vue?vue&type=script&lang=js&"
export * from "./SidebarGeometryInput.vue?vue&type=script&lang=js&"
import style0 from "./SidebarGeometryInput.vue?vue&type=style&index=0&id=0dedaebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dedaebc",
  null
  
)

export default component.exports